import React, { useEffect, useState } from "react";
import { Button, Modal, ButtonProps } from "antd";
import { InputNumber, Radio } from "antd";
import { PaymentManualIcon, PaymentAutoIcon } from "../icons";
import ModalPaymentMoney from "./ModalPaymentMoney";
import ModalPaymentBoundCard, {
  ModalPaymentBoundCardButton,
} from "./ModalPaymentBoundCard";
import { useModalStore } from "@/hooks/useModalStore";
import "./ModalAddPayment.scss";
import { usePaymentStore } from "@/hooks/usePaymentStore";
import { useTranslation } from "react-i18next";

const ModalAddPayment: React.FC<{}> = () => {
  const { t } = useTranslation();
  const {
    showModalAddPayment,
    setShowModalAddPayment,
    addPaymentModalTypeList,
  } = useModalStore();
  const modalTypeList = addPaymentModalTypeList;
  const [method, setMethod] = useState(modalTypeList?.[0] || "manual");
  const [amount, setAmount] = useState(0);
  const [buttonLoading, setButtonLoading] = useState(false);

  return (
    <>
      <Modal
        title={t('components.modalAddPayment.title')}
        open={showModalAddPayment}
        onCancel={() => {
          setShowModalAddPayment(false);
        }}
        width={656}
        footer={() => {
          return [
            <Button
              key="cancel"
              onClick={() => {
                setShowModalAddPayment(false);
              }}
            >
              {t('components.modalAddPayment.cancel')}
            </Button>,
            method === "manual" && (
              <ModalPaymentMoney
                key="amount"
                amount={amount}
                disabled={!amount}
                buttonLoading={buttonLoading}
                setButtonLoading={setButtonLoading}
              />
            ),
            method === "auto" && (
              <ModalPaymentBoundCardButton
                key="card"
                buttonName={t('components.modalAddPayment.next')}
                buttonProps={{ size: "middle", type: "primary" }}
              />
            ),
          ];
        }}
      >
        <div className="flex flex-col items-center mb-8">
          <div className="flex gap-4 w-full">
            {modalTypeList?.map((el) => {
              return (
                <PaymentCard
                  key={el}
                  value={method}
                  type={el}
                  onClick={() => setMethod(el)}
                />
              );
            })}
          </div>
          {method === "manual" ? (
            <div className="w-full flex flex-col items-start gap-1 mt-4">
              <div className="text-[#171717] text-xs font-medium  leading-tight">
                {t('components.modalAddPayment.topUpAmount')}
              </div>
              <InputNumber
                size="large"
                style={{ width: "100%" }}
                placeholder={""}
                onChange={(value) => setAmount(Number(value))}
                precision={2}
                addonBefore="USD"
                min={0}
              />
            </div>
          ) : null}
        </div>
      </Modal>
    </>
  );
};

export default ModalAddPayment;

export const ModalAddPaymentButton = ({
  buttonName,
  buttonProps,
  modalTypeList = ["manual", "auto"],
}: {
  buttonName: React.ReactNode;
  buttonProps: ButtonProps;
  modalTypeList?: ("manual" | "auto")[];
}) => {
  const { setShowChargeModal, setAddPaymentModalTypeList } = useModalStore();
  const { reQueryWalletData } = usePaymentStore();
  return (
    <Button
      className="black-button"
      size="large"
      onClick={() => {
        reQueryWalletData();
        setShowChargeModal(true); // 点击打开 支付方式选择弹窗
        setAddPaymentModalTypeList(modalTypeList);
      }}
      {...buttonProps}
    >
      {buttonName}
    </Button>
  );
};

const PaymentCard = ({
  value,
  type,
  onClick,
}: {
  value: string;
  type: "manual" | "auto";
  onClick: () => void;
}) => {
  const { t } = useTranslation();
  const isActive = type === value;
  const Icon = type === "manual" ? PaymentManualIcon : PaymentAutoIcon;
  const cardMap: any = {
    manual: {
      title: t('components.modalAddPayment.addFunds'),
      desc: t('components.modalAddPayment.addFundsDesc'),
    },
    auto: {
      title: t('components.modalAddPayment.addCard'),
      desc: t('components.modalAddPayment.addCardDesc'),
      // disabled: true
    },
  };

  return (
    <div
      className={`p-6 flex-1 bg-white rounded-2xl border  justify-start items-start gap-16 inline-flex hover:cursor-pointer h-[72px]
      ${isActive ? "border-[#FB6011]" : "border-[#D9D9E0]"}
      ${cardMap[type]?.disabled ? "payment-modal-item-disabled" : ""}
      `}
      onClick={() => {
        if (cardMap[type]?.disabled) {
          return;
        }
        onClick();
      }}
    >
      <div className={`payment-modal-container`}>
        <div className="payment-modal-container-left">
          <Icon />
          {cardMap[type]?.title}
        </div>
        <div className="payment-modal-container-right">
          <Radio checked={isActive} />
        </div>
      </div>
    </div>
  );
};
